import { openBlock as t, createElementBlock as a, renderSlot as o, resolveComponent as r, createBlock as i, withCtx as l, createVNode as d } from "vue";
import { _ as c } from "./_plugin-vue_export-helper-dad06003.js";
import { L as k } from "./LinkGrayMd-9ecb8e08.js";
import { B as u } from "./ButtonDot-e5797691.js";
const L = {}, h = { class: "ct-link-gray ct-link-sm" };
function y(n, e) {
  return t(), a("p", h, [
    o(n.$slots, "default")
  ]);
}
const B = /* @__PURE__ */ c(L, [["render", y]]), D = {}, G = { class: "ct-link-gray ct-link-lg" };
function g(n, e) {
  return t(), a("p", G, [
    o(n.$slots, "default")
  ]);
}
const S = /* @__PURE__ */ c(D, [["render", g]]), x = {}, E = { class: "ct-link-gray ct-link-xl" };
function M(n, e) {
  return t(), a("p", E, [
    o(n.$slots, "default")
  ]);
}
const X = /* @__PURE__ */ c(x, [["render", M]]), C = {}, v = { class: "ct-link-error ct-link-sm" };
function w(n, e) {
  return t(), a("p", v, [
    o(n.$slots, "default")
  ]);
}
const nn = /* @__PURE__ */ c(C, [["render", w]]), N = {}, V = { class: "ct-link-error ct-link-md" };
function b(n, e) {
  return t(), a("p", V, [
    o(n.$slots, "default")
  ]);
}
const tn = /* @__PURE__ */ c(N, [["render", b]]), j = {}, q = { class: "ct-link-error ct-link-lg" };
function z(n, e) {
  return t(), a("p", q, [
    o(n.$slots, "default")
  ]);
}
const on = /* @__PURE__ */ c(j, [["render", z]]), A = {}, F = { class: "ct-link-error ct-link-xl" };
function H(n, e) {
  return t(), a("p", F, [
    o(n.$slots, "default")
  ]);
}
const cn = /* @__PURE__ */ c(A, [["render", H]]), I = {
  components: {
    LinkGraySm: B,
    ButtonDot: u
  }
};
function J(n, e, f, $, p, m) {
  const s = r("ButtonDot"), _ = r("LinkGraySm");
  return t(), i(_, null, {
    default: l(() => [
      d(s),
      o(n.$slots, "default")
    ]),
    _: 3
  });
}
const en = /* @__PURE__ */ c(I, [["render", J]]), K = {
  components: {
    LinkGrayMd: k,
    ButtonDot: u
  }
};
function O(n, e, f, $, p, m) {
  const s = r("ButtonDot"), _ = r("LinkGrayMd");
  return t(), i(_, null, {
    default: l(() => [
      d(s),
      o(n.$slots, "default")
    ]),
    _: 3
  });
}
const rn = /* @__PURE__ */ c(K, [["render", O]]), P = {
  components: {
    LinkGrayLg: S,
    ButtonDot: u
  }
};
function Q(n, e, f, $, p, m) {
  const s = r("ButtonDot"), _ = r("LinkGrayLg");
  return t(), i(_, null, {
    default: l(() => [
      d(s),
      o(n.$slots, "default")
    ]),
    _: 3
  });
}
const sn = /* @__PURE__ */ c(P, [["render", Q]]), R = {
  components: {
    LinkGrayXl: X,
    ButtonDot: u
  }
};
function T(n, e, f, $, p, m) {
  const s = r("ButtonDot"), _ = r("LinkGrayXl");
  return t(), i(_, null, {
    default: l(() => [
      d(s),
      o(n.$slots, "default")
    ]),
    _: 3
  });
}
const _n = /* @__PURE__ */ c(R, [["render", T]]);
export {
  sn as LinkDotLg,
  rn as LinkDotMd,
  en as LinkDotSm,
  _n as LinkDotXl,
  on as LinkErrorLg,
  tn as LinkErrorMd,
  nn as LinkErrorSm,
  cn as LinkErrorXl,
  S as LinkGrayLg,
  k as LinkGrayMd,
  B as LinkGraySm,
  X as LinkGrayXl
};
